import React, { Component } from 'react';
import {observer} from 'mobx-react';
import ViewState from "./ViewState";
import API from "./API";

@observer
class Search extends Component {
    constructor(props) {
        super(props);
        this.state = { searchFieldFocus: false }
        this.searchChange = this.searchChange.bind(this);
        this.searchBlur = this.searchBlur.bind(this);
        this.searchFocus = this.searchFocus.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    searchBlur() {
        this.setState({searchFieldFocus: false});
    }

    searchFocus() {
        this.setState({searchFieldFocus: true});
    }

    searchChange(args) {
        let viewState = this.props.appState.viewState;
        switch (viewState) {
            case ViewState.table:
                break;
            case ViewState.detail:
            default:
                let history = this.props.history;
                history.push('/');
                break;
        }

        let currentSearch = this.searchField.value.toLowerCase();
        this.props.appState.searchCursor = 0;
        this.props.appState.searchQuery = currentSearch;
        API.searchCoin(this.props.appState, currentSearch);
    }

    clearSearch() {
        this.searchField.value = "";
        this.searchField.focus();
        this.props.appState.searchQuery = "";
        this.props.appState.searchResults = {};
        this.props.appState.searchCursor = 0;
    }

    handleKeyDown(e) {
        let appState = this.props.appState;
        const coins = appState.searchResults.coins;

        if (!coins) { return; }

        const cursor = appState.searchCursor;
        // arrow up/down button should select next/previous list element
        if (e.keyCode === 38 && cursor > 0) {
            appState.searchCursor = cursor - 1;
            e.preventDefault(); // Let's stop this event.
            e.stopPropagation(); // Really this time.
        } else if (e.keyCode === 40 && cursor < coins.length - 1) {
            appState.searchCursor = cursor + 1;
            e.preventDefault(); // Let's stop this event.
            e.stopPropagation(); // Really this time.
        } else if (e.keyCode === 13) {
            if (appState.searchSelectedCoin && appState.searchSelectedCoin.symbol) {
                this.props.history.push('/coin/' + appState.searchSelectedCoin.symbol);
                this.clearSearch();
                e.preventDefault(); // Let's stop this event.
                e.stopPropagation(); // Really this time.
            }
        }
    }

    render() {
        let searchFocusedClass = this.state.searchFieldFocus ? 'search-focus' : '';
        let searchValue = this.props.appState.searchQuery || '';
        let removeButton = null;
        if (searchValue) {
            removeButton = (
                <span
                    className="search-input-addon clickable no-hover input-group-addon glyphicon glyphicon-remove"
                    style={{top: 0}}
                    id="clear-search"
                    onClick={this.clearSearch}
                />
            );
        }

        return (
            <div className={'cg-searchfield input-group input-group ' + searchFocusedClass}>
                <span
                    className="search-input-addon input-group-addon glyphicon glyphicon-search"
                    style={{top: 0}}
                    id="search-addon"
                />
                <input type="text"
                       className={'search-input form-control'}
                       placeholder="Search & filter"
                       aria-describedby="search-addon"
                       ref={(input) => { this.searchField = input; }}
                       value={this.props.appState.searchQuery}
                       onChange={this.searchChange}
                       onBlur={this.searchBlur}
                       onFocus={this.searchFocus}
                       onKeyDown={ this.handleKeyDown }
                />
                { removeButton }
            </div>
        );
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/Search.js